export enum SortOrder {
    ASC,
    DESC,
}

export type SortSettings = {
    sortBy: string | number;
    order: SortOrder;
};
